module.exports = __webpack_public_path__ + "img/onlylive-logo.80b5d014.png";